<template>
    <div class="page-header page-header-light">
        <div class="page-header-content header-elements-md-inline">
            <div class='page-title d-flex'>
                <div v-if="loading" style="width: 250px; height: 29px; background-color: #dcdbdc; border-radius: 3px;"></div>
                <h4 v-else>
                    <span class='font-weight-semibold'>{{ showTitle }}</span><span v-if="showTitleSub"> - {{ showTitleSub }}</span><span v-if="showTitleId>0"> #{{ showTitleId }}</span>
                </h4>
            </div>
            <div v-if="!loading && showButtons.length>0" class="header-elements d-none">
                <div class="d-flex justify-content-center">
                    <a v-for="(button, b_index) in showButtons" :key="b_index" :href="button.url" class="btn btn-link btn-float text-body"><i v-bind:class="button.icon"></i> <span>{{ button.text }}</span></a>
                </div>
            </div>
            <div v-else-if="!loading"  class="header-elements d-none">
                <div class="d-flex justify-content-center">
                    <slot name="header-elements"></slot>
                </div>
            </div>
        </div>
        <div v-if="breadcrumbs.length>0" class="breadcrumb-line breadcrumb-line-light header-elements-md-inline">
            <div v-if="loading" style="padding: 10px 0;">
                <div v-if="loading" style="width: 200px; height: 20px; background-color: #dcdbdc; border-radius: 3px;"></div>
            </div>
            <div v-else class="d-flex">
                <a class="breadcrumb-item" href="/"><i class="icon-home2 position-left"></i> Home</a>
                <a v-for="(item, i_index) in showBreadcrums" :key="i_index" :href="item.url" class="breadcrumb-item" v-bind:class="{ 'active':i_index === Object.keys(showBreadcrums).length - 1 }">{{ item.text }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import { getActiveHead } from 'unhead';
import { debounce } from 'lodash';
import { usePageHeaderStore } from '@services/pinia/PageHeaderStore';

export default {
    name: 'LimitlessPageHeader',
    props: {
        title: {
            type: String,
            default: '',
        },
        subTitle: {
            type: String,
            default: '',
        },
        titleId: {
            type: [String, Number],
            default: 0,
        },
        titleTemplate: {
            type: String,
            default: '',
        },
        breadcrumbs: {
            type: Array,
            default() {
                return [];
            },
        },
        loading: {
            type: Boolean,
            default: false,
        },
        buttons: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    mounted() {
        this.updateTitle();
    },
    watch: {
        showTitle() {
            this.updateTitle();
        },
        showTitleSub() {
            this.updateTitle();
        },
        showTitleId() {
            this.updateTitle();
        },
        showTitleTemplate() {
            this.updateTitle();
        },
    },
    methods: {
        updateTitle: debounce(function updateTitle() {
            const params = {
                title: this.showTitle,
                subtitle: this.showTitleSub,
                id: this.showTitleId.toString(),
                app: window.config.app.name,
            };
            getActiveHead().push({
                title: this.showTitle,
                templateParams: params,
                titleTemplate: this.showTitleTemplate + ' - %app',
            }, {
                processTemplateParams: true,
            });
        }, 300),
    },
    computed: {
        has_header_elements_slot() {
            return !!this.$slots['header-elements'];
        },
        showTitle() {
            return this.title || usePageHeaderStore().title;
        },
        showTitleSub() {
            return this.subTitle || usePageHeaderStore().sub_title;
        },
        showTitleId() {
            return this.titleId || usePageHeaderStore().title_id;
        },
        showButtons() {
            return this.buttons || usePageHeaderStore().buttons;
        },
        showBreadcrums() {
            return this.breadcrumbs || usePageHeaderStore().breadcrumbs;
        },
        showTitleTemplate() {
            if (this.titleTemplate) {
                return this.titleTemplate;
            }
            let template = '';
            if (this.showTitle) {
                template = '%title';
            }
            if (this.showTitleSub) {
                if (this.showTitleId) {
                    template = '%subtitle #%id - ' + template;
                } else {
                    template = '%subtitle - ' + template;
                }
            } else if (this.showTitleId) {
                template += ' #%id';
            }

            return (template || null);
        },
    },
};
</script>
